module.exports = __webpack_public_path__ + "static/media/carpooling.80e59496.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/carpooling.mp4
// module id = 304
// module chunks = 0